import { type UseModalState, useModalState } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";

import { AutoClockOutWarningBottomSheet } from "../Dialogs/AutoClockOutWarningBottomSheet";
import { DatePill } from "./DatePill";
import { OvertimeDisplay } from "./OvertimeDisplay";
import { RegularTimeDisplay } from "./RegularTimeDisplay";
import { WarningCallout } from "./WarningCallout";

interface CircleProgressContentProps {
  hasExceededOvertimeThreshold: boolean;
  includeDatePill: boolean;
  shiftStartDate: Date;
  isOvertime: boolean;
  progress: number;
  overtimeText: string;
  totalTimeWorked: string;
  timeWorked: string;
  timeLeft: string;
  clockOutModalState: UseModalState;
}

export function ShiftCircleProgressContent(props: CircleProgressContentProps) {
  const {
    hasExceededOvertimeThreshold,
    includeDatePill,
    shiftStartDate,
    isOvertime,
    progress,
    overtimeText,
    totalTimeWorked,
    timeWorked,
    timeLeft,
    clockOutModalState,
  } = props;

  const autoClockOutWarningModalState = useModalState();

  return (
    <>
      <Stack
        data-testid="shift-circle-progress-content"
        alignItems="center"
        justifyContent="center"
        gap={4}
        sx={{
          paddingTop: includeDatePill ? 0 : 6,
          paddingBottom: includeDatePill || hasExceededOvertimeThreshold ? 6 : 0,
          height: "100%",
          width: "100%",
          // parent (CircleProgress) has pointerEvents: "none" so we need an override here
          pointerEvents: hasExceededOvertimeThreshold ? "auto" : "none",
        }}
        onClick={
          hasExceededOvertimeThreshold
            ? () => {
                autoClockOutWarningModalState.openModal();
              }
            : undefined
        }
      >
        {hasExceededOvertimeThreshold && <WarningCallout />}
        {includeDatePill && <DatePill startDate={shiftStartDate} />}
        {isOvertime ? (
          <OvertimeDisplay
            hasExceededOvertimeThreshold={hasExceededOvertimeThreshold}
            progress={progress}
            overtimeText={overtimeText}
            totalTimeWorked={totalTimeWorked}
          />
        ) : (
          <RegularTimeDisplay timeWorked={timeWorked} timeLeft={timeLeft} />
        )}
      </Stack>
      <AutoClockOutWarningBottomSheet
        modalState={autoClockOutWarningModalState}
        clockOutModalState={clockOutModalState}
      />
    </>
  );
}
